import { useQuery } from '@apollo/client';
import React from 'react';
import Avatar from '../../components/Avatar';
import useIsPublicView from '../../utils/useIsPublicView';
import { gql } from '../../graphql/generated/gql';

const USER_QUERY = gql(`
  query UserMentionIcon($id: ID!) {
    user(id: $id) {
      id
      ...Avatar_user
    }
  }
`);

const PUBLIC_USER_QUERY = gql(`
  query PublicUserMentionIcon($id: ID!) {
    user: publicUser(id: $id) {
      id
      ...Avatar_user
    }
  }
`);

interface UserMentionIconProps {
  id: string;
}

const UserMentionIcon = ({ id }: UserMentionIconProps) => {
  const isPublicView = useIsPublicView();
  const { data } = useQuery(isPublicView ? PUBLIC_USER_QUERY : USER_QUERY, {
    variables: { id },
  });

  return data?.user ? <Avatar user={data.user} size="small" /> : null;
};

export default UserMentionIcon;
